//internal-deps
import { PAYMENT_INITIAL_STATE } from "@swiggy-private/payment-client";

//constants
import { WEB_PAYMENTS_QUERY_PARAMS } from "@client/constants";

function getQueryParams(path: string): URLSearchParams {
    const segments = path.split("?");
    return new URLSearchParams(segments[1] || "");
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getRouteData = (queryParams: URLSearchParams): any => {
    const state = queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.state) as PAYMENT_INITIAL_STATE;

    if (state === PAYMENT_INITIAL_STATE.LINK_WALLET_WITH_NUMBER) {
        return {
            walletCode: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.walletCode),
        };
    }
    if (state === PAYMENT_INITIAL_STATE.ADD_MONEY_AND_DELINK_WALLET) {
        return {
            walletCode: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.walletCode),
            fromWalletPage: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.fromWalletPage),
        };
    }

    if (state === PAYMENT_INITIAL_STATE.DINEOUT_SUCCESS_SCREEN) {
        return {
            orderId: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.orderid),
            successScreen: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.state),
            flowType: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.flowType),
            dealId: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.dealId),
        };
    }
    // get the routedata from here for DO_SS_page

    if (state === PAYMENT_INITIAL_STATE.TURBO_PLACE_ORDER) {
        return {
            selectedTurboMethod: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.selectedturbomethod),
        };
    }

    // to get query parameters for offer banner
    if (state === PAYMENT_INITIAL_STATE.ADD_NEW_CARD) {
        return {
            isOfferEnabled: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.isOfferEnabled),
            imageId: queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.imageId),
        };
    }

    return;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getPaymentInitialState(path: string): { state: PAYMENT_INITIAL_STATE; routeData: any } {
    const queryParams = getQueryParams(path);
    const state = queryParams.get(WEB_PAYMENTS_QUERY_PARAMS.state) as PAYMENT_INITIAL_STATE;
    const routeData = getRouteData(queryParams);

    return {
        state,
        routeData,
    };
}
